import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Contact from './pages/Contact'
import Privacy from './pages/Privacy'
import Careers from './pages/Careers'
import ScrollToTop from './components/ScrollToTop'
import SkipToContent from './components/SkipToContent'
import './styles/App.css'

function App() {
  return (
    <Router>
      <div className="app">
        <SkipToContent />
        <Header />
        <main id="main-content">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/over-ons" element={<About />} />
            <Route path="/diensten" element={<Services />} />
            <Route path="/werk-en-leren" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
